
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBeaconTowerCross as ObiBeaconTowerCrossElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-beacon-tower-cross.js';
 
 
 

 
 export const ObiBeaconTowerCross = createComponent({
   react: React,
   tagName: 'obi-beacon-tower-cross',
   elementClass: ObiBeaconTowerCrossElement,
   events: {
     
   }
  });
 
 